import { ArrowRightIcon } from "@heroicons/react/solid";
import React from "react";
import '../customcss.css'

export default function Footer() {
  return (
  

    <header className=" bg-gray-800 md:sticky top-0 ">
      <div className="center text-sm">
<p>Copyright 2023</p>
<p>Tiranat Kamklai</p>
      </div>
    </header>
  );
}
